"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchClientJsonPayloadError = void 0;
class FetchClientJsonPayloadError extends Error {
    constructor(msg, payload, statusCode) {
        super(msg);
        this.payload = payload;
        this.statusCode = statusCode;
        /**
         * Support instanceof operator
         * @see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
         */
        Object.setPrototypeOf(this, new.target.prototype);
    }
    get jsonPayload() {
        if (typeof this.payload === 'object' && this.payload) {
            return this.payload;
        }
        return null;
    }
}
exports.FetchClientJsonPayloadError = FetchClientJsonPayloadError;
